import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHardwareBack } from 'Hooks/useHardwareBack';

/**
 * Android's hardware or gesture Back on the repertoire list: the roadmap, the app's home. The
 * list's only on-screen Back (the level filter's "Back to roadmap") goes to the roadmap too.
 * Walking history instead went back onto the player the list was reached from (the player's Back
 * opens the list), and from there to the list again, never the roadmap.
 */
export const useRepertoireListBack = (): void => {
  const navigate = useNavigate();
  // Set once Back has asked for the roadmap: a second press before it renders does not navigate
  // again.
  const leavingRef = useRef(false);
  const backToRoadmap = useCallback(() => {
    if (leavingRef.current) return;
    leavingRef.current = true;
    navigate('/roadmap');
  }, [navigate]);
  useHardwareBack('/repertoire', backToRoadmap);
};
